import { render, staticRenderFns } from "./ProductGroupForExpertizeAddNew.vue?vue&type=template&id=494d27dc&scoped=true&"
import script from "./ProductGroupForExpertizeAddNew.vue?vue&type=script&lang=js&"
export * from "./ProductGroupForExpertizeAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupForExpertizeAddNew.vue?vue&type=style&index=0&id=494d27dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d27dc",
  null
  
)

export default component.exports